<template lang="html">
  <div id="blog-page">

    <section class="container oversized-container articles-section">
      <div class="row mb-3">
        <div class="col-12 col-title" data-aos="fade-up">
          <h2 class="title-g1"><span>Comunicados</span></h2>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-lg-4 col-article-sample-1" v-for="(blog, index) in blogs" :key="index">
          <router-link class="box-article" :to="'/comunicados/'+blog.id">
            <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+blog.imageUrl+')' }">
              <img src="public/images/shared/empty.png">
            </div>

            <div class="box-descr">
              <h5>{{ blog.title }}</h5>
              <div class="descr" v-html="blog.body"></div>
            </div>
          </router-link>
        </div>

      </div>

      <!-- <div class="row mt-3">
        <div class="col-12 col-pagination-sample-1">
          <b-pagination-nav :link-gen="linkGen" :number-of-pages="10" use-router></b-pagination-nav>
        </div>
      </div> -->
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      formSearch: {
        keywords: null
      },

      blogs: [
        
      ],
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
    },

    linkGen(pageNum) {
      return {
        name: 'comunicados',
        query: { keywords: this.$route.query.keywords, page: pageNum }
      }
    },

    getBlogs: function(){
        axios.get(tools.url('/api/blogs')).then((response)=>{
            this.blogs = response.data;
        });
    }
  },

  mounted(){
      this.getBlogs();
  },
}
</script>
